import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
Vue.use(Vuex)
// 应用初始状态
const state = {
  count: 10,
  roleList: [],//角色列表
  privileges: [],//权限列表
  activiId:null,
  tabInfo: {
    tablist: [], //菜单列表
    id: null,//激活菜单
  },
  setting:{},
  paycode:[],//支付方式code
  menudata:[],//菜单列表
  menulist:[],
  isLogin: false,//是否登陆
  privilegescheck:[],//按钮权限

}

// 定义所需的 mutations
const mutations = {
  INCREMENT(state) {
    state.count++
  },
  DECREMENT(state) {
    state.count--
  },
  GETROLELIST(state, list) {
    state.roleList = list
  },
  GETpaycode(state,list){
    state.paycode=list
  },
  GETprivileges(state, list) {
    state.privileges = list
  },
  gerseet(state, list){
     state.setting=list
  },
  gerprivilegescheck(state, list){
    state.privilegescheck=list
    sessionStorage.setItem("privilegescheck", list);
  },
  AddTab(state, data) {
    //判断是否已经打开过
    var list = state.tabInfo.tablist
    if (list.length > 0) {
      var index = $.inArray(data.list)
    }
    state.tabInfo.tablist.splice(index, 1)
    state.tabInfo.push(data)
  },
  // ActivitabId(state,id){
  //   state.tabInfo.id=id
  // },
  //   GETmenudata(state, list) {

  //     state.menudata = list
  //   },
  SIGN_Login(state, data) { //登入，保存状态  
    if(data.menudata){
      state.menudata = data.menudata;// 
    }
    if(data.privilegescheck){
      state.privilegescheck=data.privilegescheck 
    }
    if(data.roleList){
      state.roleList= data.roleList;// 
    }
    if(data.privileges){
      state.privileges= data.privileges;// 
    }
    if(data.setting){
      state.setting= data.setting;// 
    }
    if(data.paycode){
      state.paycode= data.paycode;//
    }
    if(data.activiId){
      state.activiId= data.activiId;//
    }
    if(data.menulist){
      state.menulist= data.menulist;//
    }
    sessionStorage.setItem("state", JSON.stringify(state));
    // sessionStorage.setItem("isLogin", true);
    // state.isLogin = true
  }, 
  SIGN_OUT(state) { //退出，删除状态  
    sessionStorage.removeItem("state");
    state.menudata = '' //  
    state.privilegescheck = '' // 
    state.roleList = '' // 
    state.privileges = '' // 
    state.setting = '' // 
    state.paycode = '' // 
    state.isLogin = false
  }
}
// 创建 store 实例
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js